Submits a batch of signals representing the progression of candidates and positions through a recruitment process.

Up to 100 signals can be sent in a single request.
